import { useState } from "react";
import ToastContainer from 'react-bootstrap/ToastContainer';
import Toast from 'react-bootstrap/Toast';
import CloseButton from 'react-bootstrap/CloseButton';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import React from "react";

interface OfferModalProps {
  onOfferClose: () => void;
  showModal: boolean;
  maxStreak: number;
  userId: string;
}

function OfferModal(props: OfferModalProps) {
  const [showToast, setShowToast] = useState(false);
  
  const width = Math.min(window.innerHeight, window.innerWidth) * 0.05;

  const copyCode = () => {
    const code = props.userId.slice(-4).toUpperCase();
    navigator.clipboard.writeText(code);
    setShowToast(true);
  }

  return (
    <>
      <Modal
        show={props.showModal}
        className='offer-modal'
        size='sm'
        animation={true}
      >
        <div className="close-button-container">
          <CloseButton onClick={() => props.onOfferClose()} />
        </div>
        <Modal.Body style={{marginTop: width}}>
          <div style={{fontSize: 48, fontWeight: 'bold'}}>Congrats!</div>
          <div style={{fontSize: 20, marginTop: 20, lineHeight: 1.4, textAlign: 'center'}}>
            <div>You've reached a streak of {props.maxStreak}—awesome work!</div>
            <div style={{marginTop: 10}}>As a thank you for playing Puzzli, please message me on instagram to claim some <span style={{fontWeight: 'bold'}}>free Puzzli merch!</span></div>
          </div>
          <div style={{fontSize: 24, marginTop: 20, fontWeight: 'bold', textAlign: 'center'}}>
            Code: {props.userId.slice(-4).toUpperCase()}
          </div>
        </Modal.Body>
        <Modal.Footer style={{textAlign: 'center', justifyContent: 'center'}}>
          <Button 
            variant="primary"
            onClick={() => copyCode()} 
            style={{margin: 15, width: 120}}>
            Copy Code
          </Button>
          <Button 
            variant="outline-primary"
            onClick={() => window.open('https://instagram.com/puzzli_game', '_blank')}
            style={{margin: 15, width: 120}}>
            Instagram
          </Button>
        </Modal.Footer>
        <ToastContainer position="middle-center">
          <Toast show={showToast} onClose={() => setShowToast(false)} delay={2000} autohide>
            <Toast.Body>Code copied to clipboard</Toast.Body>
          </Toast>
        </ToastContainer>
      </Modal>
    </>
  );
}

export default OfferModal; 